'use client';
import { useBrand } from '@curology/ui-components-web/brand/context';
import { Navigation } from '@curology/ui-components-web/react/Navigation';
import { NavigationBar } from '@curology/ui-components-web/react/Navigation/NavigationBar';
import { NavigationBrand } from '@curology/ui-components-web/react/Navigation/NavigationBrand';

import { useFlag } from '@/utils/featureFlags/client';
import { getActiveUrls } from '@/utils/urls';

const Navbar = () => {
  const brand = useBrand();
  // Mirrors NavBar: this renders the same NavigationBrand href, so it has to
  // resolve the same destination or the logo would point at agencyskin on a
  // normal page and withagency on an error page once the flag is on.
  const isRebrandLive = useFlag('agency-rebrand');
  const brandUrls = getActiveUrls(brand, isRebrandLive);

  return (
    <Navigation>
      <NavigationBar>
        <NavigationBrand
          href={brandUrls.site.url}
          aria-label="Back to Homepage"
        />
      </NavigationBar>
    </Navigation>
  );
};

export default Navbar;
